import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { ConstructionSiteUsageStatistic } from './constructionSiteUsageStatisticTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export class ConstructionSiteUsageStatisticRepository extends EntityRepository<
  AppSynchronizationEnvironmentTypes,
  EntityName.ConstructionSiteUsageStatistic,
  AppEntityManagerEntityTypesByEntityName
> {
  public getByUserIdAndConstructionSiteId(
    userId: string,
    constructionSiteId: string
  ): ConstructionSiteUsageStatistic | null {
    return (
      this.getAll().find(
        (usageStatistic) =>
          usageStatistic.userId === userId &&
          usageStatistic.constructionSiteId === constructionSiteId
      ) ?? null
    );
  }

  public getByUserIdAndConstructionSiteIds(
    userId: string,
    constructionSiteIds: Array<string>
  ): Array<ConstructionSiteUsageStatistic> {
    return this.getAll().filter(
      (usageStatistic) =>
        usageStatistic.userId === userId &&
        constructionSiteIds.includes(usageStatistic.constructionSiteId)
    );
  }
}
